import React from "react"
import PropTypes, { bool, func } from "prop-types"
import Modal from "@/components/core/Modal/Modal"
import Button from "@/components/core/Button/Button"
import { isMobile } from "react-device-detect"

function ContactCustomerModal(props) {
  const {
    staticText,
    showModal,
    closeModal,
    contactViaEmail,
    contactViaPhone,
  } = props
  return (
    <div>
      <Modal showModal={showModal} onModalClose={closeModal}>
        <div className="ContactCustomerModal__wrapper">
          <div className="ContactCustomerModal__info">
            <div className="ContactCustomerModal__title">
              {staticText.customerInformation}
            </div>
            <div className="ContactCustomerModal__description">
              {staticText.howToContact}
            </div>
          </div>
          <div className="ContactCustomerModal__ctas">
            {contactViaPhone ? (
              <Button
                tag="anchor"
                label={staticText.phone}
                flexible
                to={contactViaPhone}
              />
            ) : null}
            {contactViaEmail ? (
              <Button
                tag="anchor"
                label={staticText.email}
                type="ghost"
                flexible
                to={contactViaEmail}
              />
            ) : null}
          </div>
        </div>
      </Modal>
    </div>
  )
}

ContactCustomerModal.propTypes = {
  showModal: bool,
  closeModal: func,
  contactViaPhone: func,
  contactViaEmail: func,
}

export default ContactCustomerModal
